(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('PageDirtyConfirmationCtrl', PageDirtyConfirmationCtrl);

    function PageDirtyConfirmationCtrl(close, $timeout) {
        const vm = this;
        vm.dismiss = dismiss;
        vm.confirm = confirm;

        $timeout( function () {
            vm.show = true;
        } );


        function dismiss() {
            close(false, 250);
        }

        function confirm() {
            close(true, 250);
        }
    }
})();